export interface DashboardInputs {
  price: number
  productCost: number
  shipping: number
  deliveryEfficiency: number // 0-100
  cpaIdeal: number
}

export interface DashboardMetrics {
  cpaIdeal: number
  grossMargin: number
  netProfit: number
  netMargin: number
  cpaBreakEven: number
  roasBreakEven: number
  funnelOrders: number
  funnelShipped: number
  funnelDelivered: number
  trafficLightState: 'green' | 'yellow' | 'red'
}

export function calculateMetrics(inputs: DashboardInputs): DashboardMetrics {
  const { price, productCost, shipping, deliveryEfficiency, cpaIdeal } = inputs
  const efficiencyDecimal = deliveryEfficiency / 100

  // Gross Margin (before ads & delivery loss)
  const grossMargin = price - productCost - shipping

  // CPA Break-Even = Gross Margin * Delivery Efficiency
  const cpaBreakEven = grossMargin * efficiencyDecimal

  // Net Profit per delivered order
  const netProfit =
    price - productCost - shipping - cpaIdeal / efficiencyDecimal

  // Net Margin
  const netMargin = price > 0 ? (netProfit / price) * 100 : 0

  // ROAS Break-Even = Price / CPA_BreakEven
  const roasBreakEven = cpaBreakEven > 0 ? price / cpaBreakEven : 0

  // Funnel (base 100 orders)
  const funnelOrders = 100
  const funnelShipped = 90
  const funnelDelivered = Math.round(efficiencyDecimal * 100)

  // Traffic Light State
  let trafficLightState: 'green' | 'yellow' | 'red'
  if (cpaIdeal < cpaBreakEven * 0.6) {
    trafficLightState = 'green'
  } else if (cpaIdeal < cpaBreakEven) {
    trafficLightState = 'yellow'
  } else {
    trafficLightState = 'red'
  }

  return {
    cpaIdeal,
    grossMargin: Math.round(grossMargin),
    netProfit: Math.round(netProfit),
    netMargin: parseFloat(netMargin.toFixed(2)),
    cpaBreakEven: Math.round(cpaBreakEven),
    roasBreakEven: parseFloat(roasBreakEven.toFixed(2)),
    funnelOrders,
    funnelShipped,
    funnelDelivered,
    trafficLightState,
  }
}

export function formatCurrency(value: number): string {
  return '$' + Math.abs(value).toLocaleString('en-US')
}
